import { AlertResponse } from "../types/media";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { EDS_DATES_ID, PEDS_DATES_ID } from "../hooks/useEdsDatesFilter";

export const checkEdsFilter = (
  alert: AlertResponse | undefined,
  filterValues: FilterValue[],
  edsType: "eds" | "peds"
): boolean => {
  if (!alert || !alert.eds || alert.eds <= 0) return false;

  const datesId = edsType === "eds" ? EDS_DATES_ID : PEDS_DATES_ID;
  const selectedValue = filterValues.find((f) => f.filterId === datesId)?.value;

  const noValueSelected =
    selectedValue == null ||
    (typeof selectedValue === "string" && selectedValue.trim() === "") ||
    (Array.isArray(selectedValue) && selectedValue.length === 0);

  if (noValueSelected) {
    return true;
  }

  const alertDates = Array.isArray(alert.edsDates) ? alert.edsDates : [];

  if (Array.isArray(selectedValue)) {
    return selectedValue.some((v) => alertDates.includes(String(v)));
  }

  return alertDates.includes(String(selectedValue));
};
